import JobSearchBanner from './JobSearchBanner'
export default JobSearchBanner
